"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextInputGroup = exports.TextInputLabel = exports.Input = exports.COLORS = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _VisibilityIcon = _interopRequireDefault(require("../images/VisibilityIcon"));

var _VisibilityOffIcon = _interopRequireDefault(require("../images/VisibilityOffIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  width: ", "\n  display: flex;\n  position: relative;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  color: ", "\n  font-size: 13px;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  margin-bottom: 23px;\n  display: flex;\n  flex-direction: ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  color: #6d7278;\n  font-size: 12px;\n  text-align: left;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  width: inherit;\n  outline: none;\n  border-style: none;\n  border-radius: 3px;\n  border: ", ";\n\n  background-color: ", ";\n  cursor: ", ";\n  height: 36px;\n  font-size: 13px;\n  color: ", ";\n  line-height: 13px;\n  padding-left: ", ";\n  font-family: 'Sofia Pro';\n\n  :focus {\n    border: 1px solid ", ";\n  }\n\n  ::placeholder {\n    color: ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var COLORS = {
  "default": '#D9DFEA',
  focused: '#35CAE2',
  error: '#FF647C',
  disabled: {
    backgroundColor: 'rgba(217,223,234,0.7)',
    color: '#AFB5C1'
  }
};
exports.COLORS = COLORS;

var customInput = function customInput(_ref) {
  var fullWidth = _ref.fullWidth,
      width = _ref.width,
      currency = _ref.currency,
      toggleVisibility = _ref.toggleVisibility,
      error = _ref.error,
      errorMessage = _ref.errorMessage,
      hidden = _ref.hidden,
      renderAction = _ref.renderAction,
      props = _objectWithoutProperties(_ref, ["fullWidth", "width", "currency", "toggleVisibility", "error", "errorMessage", "hidden", "renderAction"]);

  if (props.type === 'password') {
    return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(StyledInputContainer, {
      fullWidth: fullWidth,
      width: width
    }, /*#__PURE__*/_react["default"].createElement("input", _extends({}, props, {
      type: hidden ? 'password' : 'text'
    })), hidden ? /*#__PURE__*/_react["default"].createElement(_VisibilityOffIcon["default"], {
      onClick: function onClick() {
        return toggleVisibility(false);
      },
      style: iconStyle
    }) : /*#__PURE__*/_react["default"].createElement(_VisibilityIcon["default"], {
      onClick: function onClick() {
        return toggleVisibility(true);
      },
      style: iconStyle
    })), error && /*#__PURE__*/_react["default"].createElement(ErrorMessage, null, errorMessage));
  }

  return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(StyledInputContainer, {
    currency: currency,
    fullWidth: fullWidth,
    width: width
  }, currency && /*#__PURE__*/_react["default"].createElement("span", {
    style: currencyStyle
  }, currency), /*#__PURE__*/_react["default"].createElement("input", props), /*#__PURE__*/_react["default"].createElement("div", {
    style: iconStyle
  }, renderAction && renderAction())), error && /*#__PURE__*/_react["default"].createElement(ErrorMessage, null, errorMessage));
};

var Input = (0, _styledComponents["default"])(customInput)(_templateObject(), function (props) {
  if (props.error) {
    return "1px solid ".concat(COLORS.error);
  } else {
    return "1px solid ".concat(COLORS["default"]);
  }
}, function (props) {
  if (props.disabled) {
    return "".concat(COLORS.disabled.backgroundColor);
  }
}, function (props) {
  return props.disabled && 'not-allowed';
}, function (props) {
  if (props.disabled) {
    return "".concat(COLORS.disabled.color);
  } else {
    return '#000000';
  }
}, function (props) {
  return props.currency ? '50px' : '16px';
}, COLORS.focused, COLORS["default"]);
exports.Input = Input;

var TextInputLabel = _styledComponents["default"].label(_templateObject2());

exports.TextInputLabel = TextInputLabel;

var TextInputGroup = _styledComponents["default"].div(_templateObject3(), function (props) {
  return props.horizontal ? 'row' : 'column';
});

exports.TextInputGroup = TextInputGroup;

var ErrorMessage = _styledComponents["default"].span(_templateObject4(), COLORS.error);

var StyledInputContainer = _styledComponents["default"].div(_templateObject5(), function (props) {
  if (props.fullWidth) return '100%';
  if (props.width) return "".concat(props.width, "px");
  return '200px';
});

var iconStyle = {
  position: 'absolute',
  right: 20,
  top: 8,
  color: 'rgba(0,0,0,0.8)',
  fontSize: 17,
  cursor: 'pointer'
};
var currencyStyle = {
  position: 'absolute',
  alignSelf: 'center',
  fontFamily: 'Sofia Pro',
  paddingLeft: '10px',
  fontSize: '13px',
  color: 'rgba(0,0,0,0.8)'
};
customInput.propTypes = {
  fullWidth: _propTypes["default"].bool,
  error: _propTypes["default"].bool,
  placeholder: _propTypes["default"].string,
  type: _propTypes["default"].string.isRequired,
  width: _propTypes["default"].number,
  hidden: _propTypes["default"].bool,
  renderAction: _propTypes["default"].func
};
Input.propTypes = {
  label: _propTypes["default"].string,
  type: _propTypes["default"].string,
  placeholder: _propTypes["default"].string,
  name: _propTypes["default"].string,
  fullWidth: _propTypes["default"].bool,
  error: _propTypes["default"].bool,
  errorMessage: _propTypes["default"].string,
  testId: _propTypes["default"].string,
  onChange: _propTypes["default"].func,
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  children: _propTypes["default"].node,
  hidden: _propTypes["default"].bool,
  toggleVisibility: _propTypes["default"].func
};